/**
 * Ensure a Bulgarian VAT number has the BG prefix for display.
 * 
 * @param {string|null} vat - The VAT number to format
 * @returns {string} The VAT number with BG prefix if applicable
 */
export function ensureBgPrefix(vat) {
  if (!vat || typeof vat !== 'string') {
    return '';
  }

  const trimmedVat = vat.trim();
  
  if (!trimmedVat) {
    return '';
  }

  // If it already starts with 'bg' or 'BG', normalize it
  if (trimmedVat.toLowerCase().startsWith('bg')) {
    return 'BG' + trimmedVat.substring(2);
  }

  // If it's a 9-10 digit number, add BG prefix
  if (/^\d{9,10}$/.test(trimmedVat)) {
    return 'BG' + trimmedVat;
  }

  // Return as-is for other formats
  return trimmedVat;
}
